import { StaticDatePicker } from '@mui/x-date-pickers/StaticDatePicker';
import { Popover, PopoverProps } from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { ptBR } from 'date-fns/locale/pt-BR';
import { StaticDatePickerProps } from '@mui/x-date-pickers/StaticDatePicker';

interface CalendarPopoverProps {
  anchorEl: PopoverProps['anchorEl'];
  onClose: () => void;
  date: Date | null;
  onDateChange: (date: Date | null) => void;
  /**
   * Posição vertical do popover
   * @default 'bottom'
   */
  anchorOriginVertical?: PopoverProps['anchorOrigin']['vertical'];
  /**
   * Posição horizontal do popover
   * @default 'left'
   */
  anchorOriginHorizontal?: PopoverProps['anchorOrigin']['horizontal'];
  /**
   * Transformação vertical
   * @default 45
   */
  transformOriginVertical?: PopoverProps['transformOrigin']['vertical'];
  /**
   * Transformação horizontal
   * @default -170
   */
  transformOriginHorizontal?: PopoverProps['transformOrigin']['horizontal'];
  /**
   * Props adicionais para o DatePicker
   */
  datePickerProps?: Partial<StaticDatePickerProps>;
}

const CalendarPopup: React.FC<CalendarPopoverProps> = ({
  anchorEl,
  onClose,
  date,
  onDateChange,
  anchorOriginVertical = 'bottom',
  anchorOriginHorizontal = 'left',
  transformOriginVertical = 45,
  transformOriginHorizontal = -170,
  datePickerProps = {},
}) => {
  return (
    <Popover
      open={Boolean(anchorEl)}
      anchorEl={anchorEl}
      onClose={onClose}
      anchorOrigin={{
        vertical: anchorOriginVertical,
        horizontal: anchorOriginHorizontal,
      }}
      transformOrigin={{
        vertical: transformOriginVertical,
        horizontal: transformOriginHorizontal,
      }}
    >
      <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={ptBR}>
        <div style={{ position: 'relative' }}>
          <StaticDatePicker
            displayStaticWrapperAs="desktop"
            value={date}
            onChange={onDateChange}
            {...datePickerProps}
          />
          <div className="absolute bottom-0 right-0 py-2 px-3 flex gap-2 bg-white w-full justify-end">
            <button className="button-secondary mr-auto" onClick={() => onDateChange(null)}>
              Limpar
            </button>
            <button className="button-secondary" onClick={onClose}>
              Cancelar
            </button>
            <button className="button-secondary" onClick={onClose}>
              OK
            </button>
          </div>
        </div>
      </LocalizationProvider>
    </Popover>
  );
};
export default CalendarPopup;
